/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
/* eslint-disable no-console */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import { Stack } from '@mui/material'
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk'
import React, { useEffect, useRef } from 'react'
import { useCookies } from 'react-cookie'
import axios from '../axios'
import { awsConfig } from '../config'

function EmbedDashboard(props) {
  const { dashboardName } = props
  const [cookies] = useCookies()
  const token = cookies?.token
  const refDashboardContainer = useRef(null)

  useEffect(() => {
    const embedDashboard = async (dashboardEmbedUrl) => {
      const embeddingContext = await createEmbeddingContext({
        onChange: (changeEvent, metadata) => {
          console.log('Context received a change', changeEvent, metadata)
        },
      })

      const frameOptions = {
        url: dashboardEmbedUrl,
        container: refDashboardContainer.current,
        resizeHeightOnSizeChangedEvent: true,
        onChange: (changeEvent, metadata) => {
          switch (changeEvent.eventName) {
            case 'FRAME_MOUNTED': {
              console.log('Do something when the experience frame is mounted.')
              break
            }
            case 'FRAME_LOADED': {
              console.log('Do something when the experience frame is loaded.')
              break
            }
          }
        },
      }

      const contentOptions = {
        parameters: [
          {
            Name: 'country',
            Values: ['United States'],
          },
          {
            Name: 'states',
            Values: ['California', 'Washington'],
          },
        ],
        locale: 'en-US',
        sheetOptions: {
          singleSheet: false,
          emitSizeChangedEventOnSheetChange: false,
        },
        toolbarOptions: {
          export: false,
          undoRedo: false,
          reset: false,
        },
        attributionOptions: {
          overlayContent: false,
        },
        onMessage: async (messageEvent, experienceMetadata) => {
          switch (messageEvent.eventName) {
            case 'CONTENT_LOADED': {
              console.log('All visuals are loaded. The title of the document:', messageEvent.message.title)
              break
            }
            case 'ERROR_OCCURRED': {
              console.log('Error occurred while rendering the experience. Error code:', messageEvent.message.errorCode)
              break
            }
            case 'PARAMETERS_CHANGED': {
              console.log('Parameters changed. Changed parameters:', messageEvent.message.changedParameters)
              break
            }
            case 'SELECTED_SHEET_CHANGED': {
              console.log('Selected sheet changed. Selected sheet:', messageEvent.message.selectedSheet)
              break
            }
            case 'SIZE_CHANGED': {
              console.log('Size changed. New dimensions:', messageEvent.message)
              break
            }
            case 'MODAL_OPENED': {
              window.scrollTo({
                top: 0, // iframe top position
              })
              break
            }
          }
        },
      }

      await embeddingContext.embedDashboard(frameOptions, contentOptions)
    }

    const getDashboardEmbedUrl = async () => {
      try {
        const url = `${awsConfig.apiEndpoint}/?mode=getUrl&urlType=dashboard&openIdToken=${token}&dashboardName=${dashboardName}&timestamp=${new Date().getTime()}`
        const res = await axios.get(url, { method: 'GET' })
        const { DashboardEmbedUrl } = res.data
        if (DashboardEmbedUrl) {
          embedDashboard(DashboardEmbedUrl)
        }
      } catch (e) {
        console.log('getDashboardEmbedUrl error', e)
      }
    }

    getDashboardEmbedUrl()
  }, [])

  return (
    <Stack
      ref={refDashboardContainer}
      sx={{
        width: '100%',
        height: '100%',
      }}
    />
  )
}

export default EmbedDashboard
